import AdminUserEditPage from "@/features/system-settings/pages/AdminUserEdit";

const AdminUserEdit = () => {
  return <AdminUserEditPage />;
};
export default AdminUserEdit;
